import { render, staticRenderFns } from "./All-recipes.vue?vue&type=template&id=12cced16&"
import script from "./All-recipes.vue?vue&type=script&lang=js&"
export * from "./All-recipes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports